import React from "react";

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 167 167"
      height={props.height}
      className={props.className}
    >
      <path
        fill={props.color ? props.color : "#9897A0"}
        d="M3196.25 7728.08c0-7.62-.22-13.8-.49-13.8h-14.33c-.27 0-.48 6.21-.48 13.87v34.66c0 7.66.21 13.87.48 13.87h14.33c.27 0 .49-6.18.49-13.79v-34.81z"
        transform="matrix(10.8842 0 0 .3821 -34622 -2947.65)"
      ></path>
      <path
        fill={props.color ? props.color : "#9897A0"}
        d="M3196.25 7728.15c0-7.66-.22-13.87-.49-13.87h-14.33c-.27 0-.48 6.21-.48 13.87v34.66c0 7.66.21 13.87.48 13.87h14.33c.27 0 .49-6.21.49-13.87v-34.66z"
        transform="matrix(10.8842 0 0 .3821 -34622 -2876.3)"
      ></path>
      <path
        fill={props.color ? props.color : "#9897A0"}
        d="M3196.25 7728.15c0-7.66-.22-13.87-.49-13.87h-14.33c-.27 0-.48 6.21-.48 13.87v34.66c0 7.66.21 13.87.48 13.87h14.33c.27 0 .49-6.21.49-13.87v-34.66z"
        transform="matrix(10.8842 0 0 .3821 -34622 -2804.95)"
      ></path>
    </svg>
  );
}

export default Icon;
